import React, { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
  startOnLoad: false,
  theme: 'dark',
  securityLevel: 'loose',
  fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  themeVariables: {
    darkMode: true,
    background: '#0f172a', // slate-900
    primaryColor: '#4f46e5', // indigo-600
    primaryTextColor: '#f8fafc',
    primaryBorderColor: '#6366f1',
    lineColor: '#cbd5e1',
    secondaryColor: '#0284c7', // sky-600
    tertiaryColor: '#059669', // emerald-600
  },
});

interface MermaidDiagramProps {
  chart: string;
  className?: string;
}

export const MermaidDiagram: React.FC<MermaidDiagramProps> = ({ chart, className = '' }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [svgContent, setSvgContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(null);

    // Unique DOM ID per render
    const uniqueId = `mermaid-svg-${Math.random().toString(36).substring(2, 9)}`;

    mermaid.render(uniqueId, chart)
      .then((res) => {
        if (isMounted) {
          setSvgContent(res.svg);
          setIsLoading(false);
          setError(null);
        }
      })
      .catch((err) => {
        if (isMounted) {
          console.error('Mermaid rendering error:', err);
          setError(err?.message || 'Gagal merender diagram Mermaid');
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [chart]);

  if (isLoading) {
    return (
      <div className="p-8 text-center bg-slate-900 rounded-2xl border border-slate-800 text-slate-400 text-xs flex items-center justify-center gap-2">
        <div className="w-4 h-4 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
        <span>Merender Diagram Visual Mermaid.js...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-rose-950/80 text-rose-300 rounded-2xl border border-rose-800/80 text-xs font-mono space-y-1">
        <p className="font-bold">Gagal Merender Diagram Mermaid:</p>
        <p className="text-[11px] opacity-90">{error}</p>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className={`mermaid-wrapper overflow-x-auto p-4 sm:p-6 bg-slate-900 rounded-2xl border border-slate-800 shadow-xl flex justify-center items-center text-slate-100 ${className}`}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};
